import React from 'react';

/** Base shimmer block — pass className to control width/height. */
export const Skeleton: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`animate-pulse bg-gray-200 dark:bg-gray-800 rounded ${className}`} />
);

/** Multiple text lines with the last line shorter. */
export const SkeletonText: React.FC<{ lines?: number; className?: string }> = ({
  lines = 3,
  className = '',
}) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        className={`h-4 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`}
      />
    ))}
  </div>
);

/** Card-shaped skeleton: thumbnail area + text lines. */
export const SkeletonCard: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div
    className={`bg-white dark:bg-dark-card rounded-xl border border-gray-100 dark:border-dark-border overflow-hidden ${className}`}
  >
    {/* Thumbnail */}
    <Skeleton className="w-full h-44 !rounded-none" />
    {/* Body */}
    <div className="p-5 space-y-3">
      <Skeleton className="h-5 w-3/4" />
      <SkeletonText lines={2} />
      <div className="flex items-center justify-between pt-2">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-8 w-24 rounded-lg" />
      </div>
    </div>
  </div>
);
